export default __webpack_public_path__ + "static/media/themify.f0fc8c79.svg";